import { GroupMarketingPreferenceFormConfig } from '../../models/group-marketing-preference/group-marketing-preference-form-config.interface';
import { mockGroupMarketingPreferenceFormValue } from './group-marketing-preference-form-value.mock';

export const mockGroupMarketingPreferenceFormConfig: GroupMarketingPreferenceFormConfig =
  {
    initialValue: mockGroupMarketingPreferenceFormValue,
  };
